<template>
  <div>
    <van-nav-bar
      title="配送统计"
      :left-text="'您好，' + userInfo.emp_name"
    />
    <van-col :span="24">
      <base-datetime v-model="queryCondition.begin_arrived_time" label="送达起始" />
    </van-col>
    <van-col :span="24">
      <base-datetime v-model="queryCondition.end_arrived_time" label="送达截止" />
    </van-col>
    <van-col :span="24">
      <van-col :span="18" style="padding-left: 10px;">
        &nbsp;
      </van-col>
      <van-col :span="6" style="text-align: right; padding-right: 10px;">
        <base-button @click="query">查询</base-button>
      </van-col>
    </van-col>
    <van-col :span="24">
      <van-pull-refresh v-model="refreshing" @refresh="query">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="query"
        >
          <van-cell v-for="row in data" :key="row.id">
            <van-panel>
              <div slot="header">
                <van-col :span="18">
                  {{ row.emp_name }}
                </van-col>
                <van-col :span="6" style="font-weight: bold;">
                  数量：{{ row.delivery_count }}
                </van-col>
                <van-col :span="12" style="color: gray; font-size: 12px;">
                  基础配送费：{{ row.basic_delivery_amount | toThousandFilter }}
                </van-col>
                <van-col :span="12" style="color: gray; font-size: 12px;">
                  远程费：{{ row.distance_amount | toThousandFilter }}
                </van-col>
              </div>
              <div slot="footer">
                <van-col :span="14">
                  <span style="font-size: 16px; font-weight: bold; color: #dd6161;">总费用：{{ row.total_amount | toThousandFilter }}</span>
                </van-col>
                <van-col :span="10" style="text-align: right; padding-right: 10px;">
                  <base-button type="warning" @click="handleDetails(row)">详情</base-button>
                </van-col>
              </div>
            </van-panel>
          </van-cell>
        </van-list>
      </van-pull-refresh>
      <van-popup
        v-model="showForm"
        closeable
        close-icon="close"
        position="center"
        :style="{ width: '90%' }"
      >
        <van-col :span="24" style="text-align: center; margin-top: 20px;">
          配送详情
        </van-col>
        <van-col :span="24" v-if="dataOfDetail && dataOfDetail.length > 0">
          <van-list>
            <van-cell v-for="row in dataOfDetail" :key="row.id">
              <van-panel>
                <div slot="header">
                  <van-col :span="18">
                    {{ row.sell_code }}
                  </van-col>
                  <van-col :span="6" style="font-weight: bold;">
                    数量：1
                  </van-col>
                  <van-col :span="12" style="color: gray; font-size: 12px;">
                    基础配送费：{{ row.basic_delivery_amount | toThousandFilter }}
                  </van-col>
                  <van-col :span="12" style="color: gray; font-size: 12px;">
                    远程费：{{ row.distance_amount | toThousandFilter }}
                  </van-col>
                </div>
                <div>
                  <van-col :span="14">
                    送货人：{{ row.emp_name }}
                  </van-col>
                  <van-col :span="10">
                    收货人：{{ row.receiver }}
                  </van-col>
                  <van-col :span="14">
                    送达时间：{{ row.arrived_time }}
                  </van-col>
                  <van-col :span="10">
                    <span style="font-size: 16px; font-weight: bold; color: #dd6161;">总费用：{{ row.total_amount | toThousandFilter }}</span>
                  </van-col>
                </div>
              </van-panel>
            </van-cell>
          </van-list>
        </van-col>
      </van-popup>
    </van-col>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getDeliveryReportList, getDeliveryReportDetailList } from '@/api/delivery/order'
export default {
  name: 'DeliveryReport',
  data() {
    return {
      data: [],
      dataOfDetail: [],
      showForm: false,
      loading: false,
      finished: false,
      refreshing: false,

      selectedRow: null,

      queryCondition: {
        total: this.CONST.PAGINATION.TOTAL,
        page: this.CONST.PAGINATION.PAGE,
        rows: this.CONST.PAGINATION.MAX_ROWS,
        sort: 'id',
        order: 'desc',
        type: this.CONST.ORDER_BILL_TYPES.find(type => type.name === '销售预订单').id,

        emp_id: 0,
        begin_arrived_time: this.Utils.df(null, '{y}-{m}-{d} 00:00:00'),
        end_arrived_time: this.Utils.df(null, '{y}-{m}-{d} 23:59:59')
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  mounted() {
    this.queryCondition.emp_id = this.userInfo.emp_id
    this.query()
  },
  methods: {
    query() {
      this.data = []
      this.loading = true
      this.finished = false
      this.refreshing = false
      getDeliveryReportList(this.queryCondition).then(resp => {
        this.data = resp.rows || []
        this.queryCondition.total = resp.total
        this.loading = false
        this.finished = true
      }).catch(error => {
        this.loading = false
        this.finished = true
      })
    },
    handleDetails(row) {
      this.selectedRow = row
      const qc = this._.cloneDeep(this.queryCondition)
      qc.emp_id = row.emp_id
      getDeliveryReportDetailList(qc).then(resp => {
        this.dataOfDetail = resp.rows || []
      }).catch(error => {})
      this.showForm = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/delivery/report.vue